import request from '@/utils/sap-request'

// 经销商销售发票查询
export const apiDealerInvoiceList = (data) => {
  return request({
    url: '/sap/bc/ztpm/to_new_crm/transdata/get_ds_invoice',
    method: 'POST',
    data
  })
}

// 经销商销售发票上传
export const apiUploadInvoice = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/ds_invoice_impt',
    method: 'POST',
    data
  })
}

// 经销商销售发票详情查询
export const apiUploadInvoiceDetail = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_invoice_xq',
    method: 'POST',
    data
  })
}

// 经销商账款查询
export const apiGetDealerList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_da',
    method: 'POST',
    data
  })
}

// 经销商发票上传行项目更新
export const apiUpdateItem = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/ds_invoice_updt',
    method: 'POST',
    data
  })
}

// 经销商发票上传
export const apiUpdateSubmit = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/ds_invoice_impt',
    method: 'POST',
    data
  })
}

// 经销商市场支持费用查询
export const apiCostReportList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_dealer_msc',
    method: 'POST',
    data
  })
}

// 经销商账款期初导入
export const apiDsImport = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/da_import',
    method: 'POST',
    data
  })
}

// 经销商市场支持费用查询
export const apiMarketSupport = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_dealer_msc',
    method: 'POST',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/sap/dealer.js